export const adjacentChapterMenuNotCollapsible = {
    applicable: (target, annotation) => annotation.type === 'contents' && target.startsWith('adjacent'),
    transform: annotation => {
        annotation.properties = { ...annotation.properties, collapsible: false };
        return annotation;
    }
};

export const DEFAULT_RULES = [
    adjacentChapterMenuNotCollapsible
];

export const applyAnnotationRules = (target, ruleSet = DEFAULT_RULES) => annotation => {
    const applicableRules = ruleSet.filter(r => r.applicable(target, annotation));

    if (applicableRules.length) {
        return applicableRules.reduce((a, r) => r.transform(a), annotation);
    }

    return annotation;
}; 